import { Box, Typography } from '@mui/material';
import { BarChart } from '@mui/x-charts';

const Bar = ({ values = [], type }) => {
  if (!values?.length) {
    return (
      <Typography variant="subtitle2" textAlign="center" fontWeight="normal">
        Nenhum registro encontrado
      </Typography>
    );
  }

  const SIZE = 600;
  const STATUS_ORCAMENTO = [1, 6, 17, 19, 25, 45];
  const STATUS_SERVICO = [6, 20, 21, 26, 27, 30, 45];

  const STATUS_MAP = {
    1: { label: 'PENDENTE', color: '#FFA726' },
    6: { label: 'CONCLUÍDO', color: '#66BB6A' },
    17: { label: 'ENVIADO', color: '#42A5F5' },
    19: { label: 'NÃO APROVADO', color: '#EF5350' },
    20: { label: 'FATURAMENTO LIBERADO', color: '#26A69A' },
    21: { label: 'AGUARDANDO PEÇAS', color: '#8D6E63' },
    25: { label: 'À ENVIAR', color: '#FFCA28' },
    26: { label: 'EQUIPAMENTO DISPONIVEL', color: '#5C6BC0' },
    27: { label: 'EQUIPAMENTO DESCARTADO', color: '#EC407A' },
    30: { label: 'DIGITAÇÃO', color: '#29B6F6' },
    45: { label: 'EM EXECUÇÃO', color: '#AB47BC' },
  };

  const statusFiltrados =
    type === 'ORC'
      ? STATUS_ORCAMENTO
      : type === 'OS'
      ? STATUS_SERVICO
      : Object.keys(STATUS_MAP).map(Number);

  const tecnicos = values.map((v) => v.tecnico);
  const lookup = Object.fromEntries(values.map((v) => [v.tecnico, v]));

  const series = statusFiltrados.map((statusId) => {
    const { label, color } = STATUS_MAP[statusId];
    return {
      label,
      data: tecnicos.map((t) => lookup[t]?.[statusId] || 0),
      stack: 'total',
      color,
    };
  });

  const width = Math.max(200, tecnicos.length * 100);

  return (
    <Box display="flex" alignItems="center">
      <BarChart
        height={SIZE}
        width={width}
        xAxis={[{ scaleType: 'band', data: tecnicos }]}
        series={series}
        slotProps={{ legend: { hidden: true } }}
      />
    </Box>
  );
};

export default Bar;
